import store from '../../redux/store'
import {
    EDIT_USER_GENERALES,
    EDIT_USER_PERMISSIONS,
    EDIT_USER_RESET,
    EDIT_USER_ROLES,
    EDIT_USER_PROJECTS
} from '../../redux/redux-const'
import APIInvoke from '../../utils/APIInvoke';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';


const getState = () => {
    return store.getState().pages.editUser
}

const merge = (type, param) => {
    store.dispatch({
        type,
        payload: {
            ...getState(),
            ...param
        }
    })
}

export const reset = () => {
    store.dispatch({ type: EDIT_USER_RESET })
}

export const init = async (user) => {
    let responseUser = null
    const permissions = (await (await APIInvoke.invokeGET(`/security/permissions`)).json()).body
    const roles = (await (await APIInvoke.invokeGET(`/security/roles`)).json()).body
    const projects = (await (await APIInvoke.invokeGET(`/projects`)).json()).body.items

    if (user !== "_new") {
        responseUser = (await (await APIInvoke.invokeGET(`/users/${user}`)).json()).body
    }

    merge(EDIT_USER_GENERALES, {
        new: user === "_new",
        ...responseUser,
        roles: roles,
        selectedRoles: responseUser?.roles || [],
        selectedPermissions: responseUser?.permissions || [],
        permissions: permissions,
        projects: projects.map(p => ({ ...p, selected: responseUser?.projects?.includes(p.name) }))
    })
}

export const updateGenerales = (action) => {
    const name = action.target.name
    const type = action.target.type
    let value = action.target.value


    if (type === "checkbox") {
        value = action.target.checked
    }
    merge(EDIT_USER_GENERALES, { [name]: value })
}

export const checkRole = (e, project, role) => {
    store.dispatch({
        type: EDIT_USER_ROLES,
        payload: { project, role }
    })
}

export const checkProject = (e, projectIndex) => {
    store.dispatch({
        type: EDIT_USER_PROJECTS,
        payload: { project: projectIndex }
    })
}

export const isRoleSelected = (project, role) => {
    const state = getState()
    return state.selectedRoles.find(r => r.project === project && r.role === role) ? true : false
}

export const isPermissionSelected = (project, permission) => {
    const state = getState()
    return state.selectedPermissions.find(p => p.project === project && p.permission === permission) ? true : false
}

export const checkPermissions = (e, project, permission) => {
    store.dispatch({
        type: EDIT_USER_PERMISSIONS,
        payload: { project, permission }
    })
}


export const save = async (e, navigate) => {
    e.preventDefault()
    
    const state = getState()

    if(state.password !== state.password2) {
        toast.error("The two passwords must match")
        return
    }

    const request = {
        username: state.username,
        email: state.email,
        name: state.name,
        password: state.password,
        active: state.active,
        roles: state.selectedRoles,
        permissions: state.selectedPermissions,
        projects: state.projects.filter(p => p.selected).map(p => p.name)
    }

    const response = state.id
        ? await (await APIInvoke.invokePUT(`/users/${state.id}`, request)).json()
        : await (await APIInvoke.invokePOST(`/users`, request)).json()
    if (response.ok) {
        merge(EDIT_USER_GENERALES, {
            new: false,
            id: response.body.id
        })
        toast.success(response.message)
        navigate(`/users/${response.body.id}/edit`)
    } else {
        toast.error(response.message)
    }
}